import { useTranslation } from 'react-i18next';
import { BannerCard } from '@/containers/OffersBanner/card/BannerCard';
import Icon from './assets/icon_wallet.svg';

export const NoFeeForTopUpNewInvestors = () => {
  const { t } = useTranslation('kit');

  const props = {
    title: t('topup_fee_banner.no_fees_for_new_investors'),
    desc: t('topup_fee_banner.top_up_your_account'),
    icon: Icon,
  };

  return <BannerCard {...props} />;
};
